import { Authenticator } from "@aws-amplify/ui-react";
import { Outlet } from "react-router-dom";
import authConfig from "../aws-config";
import { Amplify } from "aws-amplify";
import { I18n } from "aws-amplify/utils";
import { translations } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";

I18n.putVocabularies(translations);
I18n.setLanguage("es");
I18n.putVocabularies({
  es: {
    "Sign In": "Iniciar sesión",
    "Incorrect username or password.": "Correo y/o contraseña incorrecto/s",
    "username is required to signUp": "El correo es requerido para registrarse",
    "password is required to signUp":
      "La contraseña es requerida para registrarse",
    "Password must have at least 8 characters":
      "La cotraseña debe tener al menos 8 caracteres",
    "Password did not conform with policy: Password must have lowercase characters":
      "La contraseña debe tener al menos una letra en minúscula",
    "Password did not conform with policy: Password must have uppercase characters":
      "La contraseña debe tener al menos una letra en mayúscula",
    "Password did not conform with policy: Password must have symbol characters":
      "La contraseña debe tener al menos un símbolo",
  },
});

const formFields = {
  signIn: {
    username: {
      label: "Email",
      isRequired: true,
    },
  },
  signUp: {
    username: {
      label: "Email",
      isRequired: true,
    },
  },
  forgotPassword: {
    username: {
      placeholder: "Enter your email:",
      label: "Email",
      isRequired: true,
    },
  },
};

const components: DefaultComponents = {
  Header() {
    return (
      <div className="flex flex-column justify-content-center align-items-center py-6">
        <style>{`
          @keyframes pulse-orange {
              0% { box-shadow: 0 0 0 0 var(--primary-color); }
              70% { box-shadow: 0 0 0 20px rgba(249, 115, 22, 0); }
              100% { box-shadow: 0 0 0 0 rgba(249, 115, 22, 0); }
          }
          .auth-logo {
              animation: pulse-orange 2s infinite;
          }
          .logo-text-gradient {
              background: linear-gradient(90deg, var(--primary-color), #FFD700);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
          }
        `}</style>
        <div className="inline-flex align-items-center justify-content-center bg-primary text-primary-inverse border-circle w-4rem h-4rem mb-3 auth-logo">
          <i className="pi pi-bolt text-3xl" />
        </div>
        <div className="text-4xl font-black text-color">
          Doing<span className="logo-text-gradient">Sports</span>
        </div>
        <p className="text-color-secondary mt-2 text-center">Gestiona tu institución deportiva</p>
      </div>
    );
  },
  SignUp: {
    Header() {
      return (
        <div className="surface-card p-4 border-round-xl mb-4">
          <h3 className="text-center font-bold text-primary m-0 mb-3">
            <i className="pi pi-shield mr-2"></i>
            Requisitos de contraseña
          </h3>
          <ul className="font-medium text-color-secondary m-0 pl-4">
            <li className="mb-2">✓ Al menos 8 caracteres</li>
            <li className="mb-2">✓ Al menos 1 número</li>
            <li className="mb-2">✓ Al menos 1 carácter especial</li>
            <li className="mb-2">✓ Al menos una letra mayúscula</li>
            <li>✓ Al menos una letra minúscula</li>
          </ul>
        </div>
      );
    },
  },
  ForgotPassword: {
    Header() {
      return (
        <div className="text-center mb-4">
          <i className="pi pi-key text-5xl text-primary mb-3"></i>
          <h2 className="font-bold text-color m-0">Recuperar contraseña</h2>
          <p className="text-color-secondary mt-2">Te enviaremos un código de verificación</p>
        </div>
      );
    },
  },
};

Amplify.configure(authConfig);

const AuthGuard = () => {
  return (
    <>
      <style>{`
        /* Estilos personalizados para el Authenticator */
        [data-amplify-authenticator] {
          --amplify-colors-background-primary: var(--surface-ground);
          --amplify-colors-background-secondary: var(--surface-card);
          --amplify-colors-border-primary: var(--surface-border);
          --amplify-colors-border-secondary: var(--surface-border);
          --amplify-colors-brand-primary-10: var(--primary-50);
          --amplify-colors-brand-primary-80: var(--primary-color);
          --amplify-colors-brand-primary-90: var(--primary-600);
          --amplify-colors-brand-primary-100: var(--primary-700);
          --amplify-colors-font-primary: var(--text-color);
          --amplify-colors-font-secondary: var(--text-color-secondary);
          --amplify-colors-font-interactive: var(--primary-color);
          --amplify-radii-small: 0.75rem;
          --amplify-radii-medium: 1rem;
          --amplify-radii-large: 1.5rem;
          --amplify-space-medium: 1.5rem;
          --amplify-space-large: 2rem;
        }
        
        [data-amplify-authenticator] [data-amplify-container] {
          background: var(--surface-card);
          border-radius: 1.5rem;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          border: 1px solid var(--surface-border);
          max-width: 28rem;
          padding: 2rem;
        }
        
        [data-amplify-authenticator] [data-amplify-router] {
          background: transparent;
          border: none;
          box-shadow: none;
        }
        
        [data-amplify-authenticator] button[type="submit"],
        [data-amplify-authenticator] button[data-variation="primary"] {
          background: linear-gradient(90deg, var(--primary-color), #FFD700);
          border: none;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
          border-radius: 2rem;
          padding: 0.75rem 2rem;
        }
        
        [data-amplify-authenticator] button[type="submit"]:hover,
        [data-amplify-authenticator] button[data-variation="primary"]:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(249, 115, 22, 0.3);
        }
        
        [data-amplify-authenticator] input {
          border-radius: 0.75rem;
          border: 2px solid var(--surface-border);
          background: var(--surface-ground);
          color: var(--text-color);
          padding: 0.75rem 1rem;
          transition: all 0.3s ease;
        }
        
        [data-amplify-authenticator] input:focus {
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
        }
        
        [data-amplify-authenticator] label {
          color: var(--text-color);
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        
        [data-amplify-authenticator] [data-amplify-footer] {
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid var(--surface-border);
        }
        
        [data-amplify-authenticator] a {
          color: var(--primary-color);
          font-weight: 600;
          text-decoration: none;
          transition: all 0.2s ease;
        }
        
        [data-amplify-authenticator] a:hover {
          text-decoration: underline;
        }
        

      `}</style>
      
      <div className="auth-background">
        <Authenticator.Provider>
          <Authenticator
            formFields={formFields}
            components={components}
          >
            <Outlet />
          </Authenticator>
        </Authenticator.Provider>
      </div>
    </>
  );
};

export default AuthGuard;
